<template>
  <div id="app">
     <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      lang: "中文",
    };
  },
  methods: {
    lang_change(value) {
      value === "英文"
        ? (() => {
            this.$i18n.locale = "en";
            this.set_cookie("lang", "en", 6);
          })()
        : (() => {
            this.$i18n.locale = "cn";
            this.set_cookie("lang", "cn", 6);
          })();
      this.lang = value;
    },
    isMobile(){
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    }
  },
  components: { }, // 定义实例内部私有组件的
  beforeCreate() { },// 实例刚在内存中被创建出来，此时，还没有初始化好 data 和 methods 属性
  created() { }, //实例已经在内存中创建OK，此时 data 和 methods 已经创建OK，此时还没有开始 编译模板
  beforeMount() { },// 此时已经完成了模板的编译，但是还没有挂载到页面中
  mounted() { 
    if (this.isMobile()) {
      this.$router.replace('/start-mobile');
    } else {
      this.$router.replace('/start');
    }
  },// 此时，已经将编译好的模板，挂载到了页面指定的容器中显示
  beforeUpdate() { },// 状态更新之前执行此函数， 此时 data 中的状态值是最新的，但是界面上显示的 数据还是旧的，因为此时还没有开始重新渲染DOM节点
  updated() { },// 实例更新完毕之后调用此函数，此时 data 中的状态值 和 界面上显示的数据，都已经完成了更新，界面已经被重新渲染好了！
  beforeDestroy() { },// 实例销毁之前调用。在这一步，实例仍然完全可用。
  destroyed() { }, //Vue 实例销毁后调用。调用后，Vue 实例指示的所有东西都会解绑定，所有的事件监听器会被移除，所有的子实例也会被销毁。
};
</script>

<style lang="less">

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

* {
  margin: 0;
  padding: 0;
}
body,
html {
  height: 100%;
  width: 100%;
}
#app {
  height: 100%;
  min-height: 100%;
}

#Login {
  height: 100%;

  .el-container {
    height: 100%;
  }

  .el-header {
    // box-shadow: 0px 3px 3px rgba(0, 82, 204, 0.1);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 100px;
  }

  // .el-main {
  //   height: 100%;
  //   position: relative;
  //   background: url(./img/login_bg.png) no-repeat bottom center / 100% auto;
  // }

  .logo {
    display: flex;
    align-items: center;
    height: 100%;

    .logo_name {
      color: #2878ff;
      font-weight: 700;
      font-size: 18px;
      margin-left: 10px;
    }
  }

  .lang-menu {
    display: flex;
    align-items: center;
  }

  .earth {
    margin-right: 5px;
  }

  .el-dropdown {
    cursor: pointer;
    position: relative;
  }

  .el-icon-caret-bottom {
    margin-left: 5px;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
}
.el-main{
  padding: 0px !important;
}
h2 {
    display: block;
    font-size: 1.5em;
    margin-block-start: 0.83em;
    margin-block-end: 0.83em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
}
.menu__collapse .newRelease {
    margin-bottom: 12px;
    width: 30px !important;
}
.menu__collapse .newRelease {
    margin-bottom: 12px;
    width: 30px;
}
.bs-menu-group-description{
  width: 30px;
    height: 30px;
}
.icon-jiahao{
  font-weight: 0;
  line-height: 30px;
}
</style>
